import gql from 'graphql-tag';

export const ALTA_COMUNICA_CLIENTE = gql(`
    mutation AltaComunicaCliente($altaComunicaClienteRequest: AltaComunicaClienteRequestInput) {
        altaComunicaCliente(altaComunicaClienteRequest: $altaComunicaClienteRequest) {
            id
            idCliente
            apellido
            idUsuario
            razon
        }
    }
`);

export const COMUNICA_CLIENTE_BY_ID_CLIENTE = gql(`
    query ComunicaClienteByIdCliente($idCliente: Long) {
        comunicaClienteByIdCliente(idCliente: $idCliente) {
            id
            idCliente
            razon
        }
    }
`);

export const COMUNICA_CLIENTE_BY_ID_CLIENTE_AND_RAZON_AND_ID_USUARIO = gql(`
    query ComunicaClienteByIdClienteAndRazonAndIdUsuario($idCliente: Long, $idUsuario: Long, $razon: String) {
        comunicaClienteByIdClienteAndRazonAndIdUsuario(idCliente: $idCliente, idUsuario: $idUsuario, razon: $razon) {
            razon
            idUsuario
            idCliente
            id
            apellido
            mail
            nombre
        }
    }  
`);

export const DELETE_COMUNICA_CLIENTE = gql(`
    mutation BorrarComunicaCliente($idComunicaCliente: Long) {
        borrarComunicaCliente(idComunicaCliente: $idComunicaCliente) {
            razon
            idUsuario
            idCliente
            id
        }
    }
`);
